import { useEffect, useState } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import find from "../../../assets/find.svg";
import { Link, useNavigate } from "react-router-dom";
import avatar from "../../../assets/images/personPlaceholder.png";
import check from "../../../assets/images/check.svg";
import moreIcon from "../../../assets/images/more.png";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import Placeholder from "../../../assets/images/Placeholder.gif";
const Listfaq = () => {
  document.title = "FAQ Listing | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [blogData, setblogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [userRoles, setUserRoles] = useState([]);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const itemsPerPage = 6;
  const navigate = useNavigate();

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const fetchblog = async (page, searchQuery = "") => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.help}?filter=faq&limit=${itemsPerPage}&page=${page}&search=${searchQuery}`
      );
      setblogData(response.data?.data || []);
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching faq data:", error);
      setblogData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchblog(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSelectChange = async (action, blogId) => {
    switch (action) {
      case "delete":
        await deleteBlog(blogId);
        break;
      case "update":
        const updatedData = {};
        await updateblog(blogId, updatedData);
        break;

      default:
        break;
    }
  };
  const handleBlogDetail = async (blogId) => {
    try {
      const response = await get(`${endpoints.help}/${blogId}`);
      navigate(`/faq-details`, { state: { blogData: response.data } });
    } catch (error) {
      console.error("Error fetching faq details:", error);
    }
  };
  const deleteBlog = async (blogId) => {
    try {
      await del(`${endpoints.help}/${blogId}`);
      setblogData((prevData) => prevData.filter((blog) => blog.id !== blogId));
      toast.success("Faq Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      fetchblog(currentPage);
    } catch (error) {
      console.error("Error deleting faq:", error);
    }
  };

  const updateblog = async (blogId, updatedData) => {
    try {
      await put(`${endpoints.blog}/${blogId}`, updatedData);
      fetchblog(currentPage, searchTerm);
    } catch (error) {
      console.error("Error updating faq:", error);
    }
  };

  const handleEditblog = (blogId) => {
    navigate(`/add-faq?blogId=${blogId}&isUpdate=true`);
  };

  const toggleDropdown = (blogId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [blogId]: !prevState[blogId],
    }));
  };

  const renderContent = (blog) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(
      blog?.content?.htmlContent || "",
      "text/html"
    );
    const textContent = doc.body.textContent || "";

    const words = textContent.split(" ") || [];

    return words.slice(0, 5).join(" ") + (words.length > 5 ? "..." : "");
  };

  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                  <div className="d-flex flex-row  justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0 ">
                    <span className=" font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0 d-md-block">
                      Helps & FAQ Listing
                    </span>

                    <div
                      className="mx-sm-3 bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{ borderRadius: "12px", height: "48px" }}
                    >
                      <img
                        src={find}
                        alt="Background"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <Link to="/add-faq">
                      <Button className="rounded-pill">Add New</Button>
                    </Link>
                  </div>
                </div>

                <div
                  className="table-responsive hide-scrollbar rounded-4"
                  style={{
                    height: blogData?.length > 0 ? "500px" : "auto",
                  }}
                >
                  <Table
                    hover
                    className="table-borderless table-centered table-nowrap"
                  >
                    <thead>
                      <tr>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Id
                        </th>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Question
                        </th>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Answer
                        </th>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Added on
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody style={{ minHeight: "550px" }}>
                      {loading ? (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center ff-sora fw-normal font-size-16"
                          >
                            Loading...
                          </td>
                        </tr>
                      ) : blogData.length > 0 ? (
                        blogData.map((blog, index) => (
                          <tr key={index}>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div>
                                  <h6 className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                    {blog?.title}
                                  </h6>
                                </div>
                              </div>
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {renderContent(blog)}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {blog.createdAt
                                ? new Date(blog.createdAt).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>
                              <Dropdown
                                isOpen={dropdownOpen[blog.id]}
                                toggle={() => toggleDropdown(blog.id)}
                                direction="down"
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-link p-0"
                                >
                                  <img src={moreIcon} alt="More options" />
                                </DropdownToggle>
                                <DropdownMenu end>
                                  <DropdownItem
                                    className="fw-normal ff-sora secondary-black font-size-14"
                                    onClick={() => handleEditblog(blog.id)}
                                  >
                                    Edit FAQ
                                  </DropdownItem>
                                  <DropdownItem
                                    className="fw-normal ff-sora secondary-black font-size-14"
                                    onClick={() =>
                                      handleSelectChange("delete", blog.id)
                                    }
                                  >
                                    Delete FAQ
                                  </DropdownItem>
                                  <DropdownItem
                                    className="fw-normal ff-sora secondary-black font-size-14"
                                    onClick={() => handleBlogDetail(blog.id)}
                                  >
                                    FAQ Detail
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center ff-sora fw-normal font-size-16"
                          >
                            {/* No records to display. */}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {!loading && blogData.length === 0 && (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                      <img
                        src={Placeholder}
                        alt="No record placeholder"
                        className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                      />
                      <p className="mt-3 ff-sora font-size-16 fw-normal">
                        No Record Found!
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Listfaq;
